import { motion } from "framer-motion";
import { FaStar } from "react-icons/fa";

export default function StarRating({ rating, setRating }) {
    return (
      <div className="star-rating">
        {[1, 2, 3, 4, 5].map((star) => (
          <motion.div
            key={star}
            whileHover={{ scale: 1.2 }}
            whileTap={{ scale: 0.9 }}
          >
            <FaStar
              className="star"
              color={star <= rating ? "#ffc107" : "#e4e5e9"}
              onClick={() => setRating(star)}
              size={20}
            />
          </motion.div>
        ))}
      </div>
    );
  };